import { useDeleteAgorder } from "http-hooks/agorder/useAgorder";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteAgorder({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteAgorder();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Order"
      description="Are you sure you want to delete this agorder? This order will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
